import { Component } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { MessageService } from 'primeng/api';
import { PartnerCreateDto, PartnerDto } from 'src/app/aplication/api/Manipulate/Partners';
import { PartnerService } from 'src/app/aplication/service/partners.service';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrl: './partners.component.scss'
})
export class PartnersComponent {
  partners:PartnerDto[] = [];
  loaded:boolean = true;
  displayAddPartner:boolean = false;
  showIsUnacitve:boolean = false;

  editingCell: { id: string, field: string } | null = null;
  originalValue: any = null;

  animationNotFound: AnimationOptions = {
      path: 'assets/Animations/animationNotFoundPages.json',
    };

  constructor(private partnerService: PartnerService, private messageService: MessageService) { }

  ngOnInit(): void {
    this.ListPartners();
  }

  ListPartners() {
    this.loaded = false;
    this.partners = [];
    this.partnerService.List().subscribe({
      next: (data) => {
        this.partners = data;
        this.loaded = true;
      },
      error: (err) => {
        console.error('Error fetching partners:', err);
        this.loaded = true;
      }
    });
  }

  ListPartnersUnactive() {
    this.loaded = false;
    this.partners = [];
    this.partnerService.ListUnactive().subscribe({
      next: (data) => {
        this.partners = data;
        this.loaded = true;
      },
      error: (err) => {
        console.error('Error fetching partners:', err);
        this.loaded = true;
      }
    });
  }


  copyLink(partner: PartnerDto) {

    this.partnerService.GetHash(partner).subscribe({
      next: async (response) => {
        const url = `https://zionn.ai/?via=${response}`;
        navigator.clipboard.writeText(url);
        this.messageService.add({
          severity: 'success',
          summary: 'Link copiado',
          detail: 'Link copiado para a área de transferência',
          life: 2000
        });
      },
      error: (err) => {
        console.error('Error fetching hash:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro ao copiar link',
          detail: 'Erro ao copiar link do parceiro',
          life: 2000
        });
      }
    });
  }

  delete(partner: PartnerDto) {
    this.partnerService.Delete(partner.id!).subscribe({
      next: (data) => {
          this.messageService.add({
              severity: 'success',
              summary: 'Parceiro deletado',
              detail: 'Parceiro deletado com sucesso',
              life: 2000
            });
              this.ListPartners();
      },
      error: (err) => {
        console.error('Error fetching partners:', err);
        this.messageService.add({
              severity: 'error',
              summary: 'Erro ao deletar parceiro',
              detail: 'Erro ao deletar parceir',
              life: 2000
            });
      }
    });
  }


  startEdit(partner: PartnerDto, field: string) {
    this.editingCell = { id: partner.id!, field };
    this.originalValue = partner[field as keyof PartnerDto];
  }

  saveCell(partner: PartnerDto) {

    this.partnerService.Edit(partner).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Atualizado',
          detail: 'Campo atualizado com sucesso',
          life: 2000
        });

        this.editingCell = null;
        this.originalValue = null;
      },
      error: () => {
        this.cancelEdit(partner);

        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao atualizar campo',
          life: 2000
        });
      }
    });
  }

  cancelEdit(partner: PartnerDto) {
    if (this.editingCell) {
      partner[this.editingCell.field as keyof PartnerDto] = this.originalValue;
    }

    this.editingCell = null;
    this.originalValue = null;
  }


  togglePartners() {
    this.showIsUnacitve = !this.showIsUnacitve;

    if (this.showIsUnacitve) {
      this.ListPartnersUnactive();
    } else {
      this.ListPartners();
    }
  }

  reactivePartner(partner: PartnerDto) {
    this.partnerService.Reactive(partner.id!).subscribe({
      next: (data) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Parceiro reativado',
          detail: 'Parceiro reativado com sucesso',
          life: 2000
        });
        this.ListPartners();
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro ao reativar parceiro',
          detail: 'Erro ao reativar parceiro',
          life: 2000
        });
      }
    });
  }

  // private toUrlSlug(value: string): string {
  //   return value
  //     .normalize('NFD')                     // separa acentos
  //     .replace(/[\u0300-\u036f]/g, '')      // remove acentos
  //     .toLowerCase()
  //     .trim()
  //     .replace(/[^a-z0-9\s-]/g, '')         // remove caracteres especiais
  //     .replace(/\s+/g, '-')                 // espaço vira hífen
  //     .replace(/-+/g, '-');                 // remove hífens duplicados
  // }

}
